import type { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export default {
    // Data point to log for when the compose form has been opened and the user has
    // begun editing

    showFullCompose: {
        customData: (
            isCharmExplicitlySet: boolean,
            entrySource: FullComposeEntrySourceType,
            viewType: FullComposeFormViewType
        ) => {
            return {
                isCharmExplicitlySet: isCharmExplicitlySet,
                entrySource: entrySource,
                viewType: viewType,
            };
        },
    },

    showFullComposeInEditMode: {
        customData: (
            item: Partial<CalendarEvent>,
            eventScope: EventScope,
            itemHasUpdates: boolean,
            fullComposeEntrySource: FullComposeEntrySourceType,
            viewType: FullComposeFormViewType,
            extractionSourceId: string,
            internetMessageId?: string
        ) => {
            return {
                fullComposeEntrySource: fullComposeEntrySource,
                viewType: viewType,
            };
        },
    },
};
